import logo from '../images/logo-light.png'
import logoComplete from '../images/logo-complete-light.png'
import logoCompleteDark from '../images/logo-complete-dark.png'
import logoHorizontalDark from '../images/logo-horizontal-dark.png'
import whatsappSvg from '../svgs/whatsapp.svg'
import instagramSvg from '../svgs/instagram.svg'
import twitterSvg from '../svgs/twitter.svg'
import facebookSvg from '../svgs/facebook.svg'
import backgroundImage1 from '../images/background-1.jpg'
import backgroundImage2 from '../images/background-2.jpg'
import backgroundImage3 from '../images/background-3.jpg'
import portrait1 from '../images/portrait-1.jpg'
import portrait2 from '../images/portrait-2.jpg'
import pascual1 from '../images/pascual-1.jpg'
import diamente1 from '../images/diamante-1.jpg'
import guemes1 from '../images/guemes-1.jpg'
import blas1 from '../images/blas-1.jpg'
import echeverria1 from '../images/echeverria-1.jpg'
import jujuyPanoramica from '../images/jujuy-panoramica.jpg'
import jujuy1 from '../images/jujuy-1.jpg'
import jujuy2 from '../images/jujuy-2.jpg'
import jujuy3 from '../images/jujuy-3.jpg'
import jujuy4 from '../images/jujuy-4.jpg'
import jujuy5 from '../images/jujuy-5.jpg'
import jujuyPortrait from '../images/jujuy-portrait.jpg'
import jujuyRender1 from '../images/jujuy-render-1.jpg'
import jujuyRender2 from '../images/jujuy-render-2.jpg'
import jujuyRender3 from '../images/jujuy-render-3.jpg'
import jujuyRender4 from '../images/jujuy-render-4.jpg'
import jujuyRender5 from '../images/jujuy-render-5.jpg'
import jujuyRender6 from '../images/jujuy-render-6.jpg'
import jujuyRender7 from '../images/jujuy-render-7.jpg'
import jujuyRender8 from '../images/jujuy-render-8.jpg'
import jujuyRender9 from '../images/jujuy-render-9.jpg'
import jujuyRender10 from '../images/jujuy-render-10.jpg'
import jujuyRender11 from '../images/jujuy-render-11.jpg'
import LopezJordan1 from '../images/lopez-jordan-1.jpg'
import LopezJordan2 from '../images/lopez-jordan-2.jpg'
import LopezJordan3 from '../images/lopez-jordan-3.jpg'
import LopezJordan4 from '../images/lopez-jordan-4.jpg'
import LopezJordan5 from '../images/lopez-jordan-5.jpg'
import LopezJordan6 from '../images/lopez-jordan-6.jpg'
import LopezJordan7 from '../images/lopez-jordan-7.jpg'
import LopezJordan8 from '../images/lopez-jordan-8.jpg'
import LopezJordan9 from '../images/lopez-jordan-9.jpg'
import LopezJordan10 from '../images/lopez-jordan-10.jpg'
import LopezJordan11 from '../images/lopez-jordan-11.jpg'
import LopezJordan12 from '../images/lopez-jordan-12.jpg'
import LopezJordan13 from '../images/lopez-jordan-13.jpg'
import LopezJordan14 from '../images/lopez-jordan-14.jpg'
import LopezJordan15 from '../images/lopez-jordan-15.jpg'
import LopezJordan16 from '../images/lopez-jordan-16.jpg'

const images = {
  // SVGS
  whatsappSvg,
  instagramSvg,
  twitterSvg,
  facebookSvg,
  // LOGOS  
  logo,
  logoComplete,
  logoCompleteDark,
  logoHorizontalDark,
  // IMAGES
  portrait1,
  portrait2,
  backgroundImage1,
  backgroundImage2,
  backgroundImage3,
  jujuyPanoramica,
  pascual1,
  diamente1,
  guemes1,
  blas1,
  echeverria1,

  jujuy1,
  jujuy2,
  jujuy3,
  jujuy4,
  jujuy5,
  jujuyPortrait,

  jujuyRender1,
  jujuyRender2,
  jujuyRender3,
  jujuyRender4,
  jujuyRender5,
  jujuyRender6,
  jujuyRender7,
  jujuyRender8,
  jujuyRender9,
  jujuyRender10,
  jujuyRender11,
  LopezJordan1,
  LopezJordan2,
  LopezJordan3,
  LopezJordan4,
  LopezJordan5,
  LopezJordan6,
  LopezJordan7,
  LopezJordan8,
  LopezJordan9,
  LopezJordan10,
  LopezJordan11,
  LopezJordan12,
  LopezJordan13,
  LopezJordan14,
  LopezJordan15,
  LopezJordan16,
} as const

export default images